import React from 'react';
import './BlockAddress.scss';

import panda434Img from './img/friday-panda_434-x2.png';
import locationImg from './img/location-x2.png';


const BlockAddress: React.FC = () => {
    return (
        <div className="block-address">
            <div className='block-address-content'>
                <div className='d-flex justify-content-center'>
                    <div className='d-block d-md-none'>
                        <img src={locationImg} alt='' className='w-100' />
                    </div>
                    <h2 className='text-white text-start text-md-center ps-2 ps-md-0'>Где можно купить Фрайди</h2>
                </div>

                <div className='row'>
                    <div className='col-6 col-md-4'>
                        <h5 className='city-name'>Москва</h5>
                        <p>Европейский ТЦ</p>
                        <p>Метрополис</p>
                        <p>ТЦ Коламбус</p>
                        <p>Галерея Аэропорт<br/>Ленинградский просп.,<br/>62А (этаж 2)</p>
                        <p>ТЦ Океания<br/>Славянский бульвар</p>
                        <p>Братиславская 2</p>
                        <p>пр-т Волгоградский, д. 78</p>
                    </div>
                    <div className='col-6 col-md-4'>
                        <h5 className='city-name'>Санкт-Петербург</h5>
                        <p>Просвещения 19</p>
                        <p>Невский 46</p>
                        <p>Лиговский 10/118</p>
                        <p>Балканская площадь 5/О</p> 
                        <p>Гражданский 41</p>
                        <p>Средний В.О. 36</p>
                        <p>КС 83 Лиговский 30А<br/>(Буквоед)</p>
                        <p>ТРК Меркурий, Савушкина<br/>141 (Буквоед)</p>
                    </div>
                    <div className='col-6 col-md-4'>
                        <h5 className='city-name'>Екатеринбург</h5>
                        <p>ул. Вайнера, д. 12</p>
                        <h5 className='city-name'>Красноярск</h5>
                        <p>ул. Сурикова, д.12</p>
                        <h5 className='city-name'>Новосибирск</h5>
                        <p>пл. Карла Маркса, д. 3</p>
                        <p>ТЦ "Галерея"<br />ул. Гоголя, 13</p>
                        <h5 className='city-name'>Воронеж</h5>
                        <p>ТЦ Пассаж, ул. 20 лет Октября д.90.</p>
                    </div>
                </div>
            </div>
            <img className="panda-434" src={panda434Img} alt="" />
        </div>
    );
};

export default BlockAddress;